// extracted by mini-css-extract-plugin
export default {"noData":"BaseTimeline_noData__vmo31"};